<div
  class="integration-company-add-card"
  [class.integration-company-add-card--disabled]="disabled"
>
  @if (showUpgradeNotice) {
    <upgrade-notice
      class="integration-company-add-card__upgrade-notice"
      [feature]="integration.featureName!"
    ></upgrade-notice>
  }

  <mat-icon
    class="integration-logo"
    [svgIcon]="integration.logo"
    aria-hidden="true"
  ></mat-icon>

  <div class="integration-company-add-card__text">
    <p class="integration-company-add-card__name">{{ integration.name }}</p>
    <p class="integration-company-add-card__description">
      {{ integration.description }}
    </p>
  </div>

  <button
    type="button"
    matButton="outlined"
    class="integration-company-add-card__button"
    [disabled]="disabled"
    [matTooltip]="disabledReason"
    [matTooltipDisabled]="!disabled || !disabledReason"
    matTooltipPosition="above"
    (click)="onAdd()"
  >
    Add Integration
  </button>
</div>
